"use strict";
var Qua = /** @class */ (function () {
    /**
     * 传入 Qua, Qua2
     * @param qua string
     */
    function Qua(qua) {
        this.softType = ''; // 软件类型 :WX|QQ|QB|QBX|QZ|TRD|TOS|EMUI|TBS
        this.platForm = ''; // 平台:ADR|AP|I|IP|WP|WIN|MAC
        this.subPlatForm = ''; // 子平台
        this.machine = ''; // 机型
        this.coreName = ''; // 内核名称:等同QUA2的CO字段;QUA2-2:IMTT:iOS系统内核
        this.coreVersion = ''; // 内核版本,等同QUA2-2中的COVN, QUA2-3的COVC
        this.version = 0; // 版本号，只适用QB/TBS版本，其他的为0，通过sParentPackageVN判断版本
        this.subVersion = ''; // 子版本，只适用QB/TBS版本，其他的空，通过sParentPackageVN判断版本
        this.betaVersion = -1; // beta版本号//B1|B2|B3.....
        this.build = -1; // 【主版本】【子版本】[build]
        this.lcId = -1; // LC ID
        this.channel = -1; // 渠道号
        this.width = -1; // 屏幕宽度
        this.height = -1; // 屏幕高度
        this.os = -1; // 操作系统版本4.4，会忽略操作系统版本号的最后一位，建议使用 osVersion
        this.osVersion = ''; // 操作系统版本号4.4.2
        this.quaVersion = -1; // QUA版本号，0:QUA版本 2:QUA2-2版本 3:QUA2-3版本
        this.productBranch = ''; // 产品分支，等同QUA2的PB字段:(GE)|PAD|TV|INT|TMS
        this.product = ''; // 产品标识，等同QUA2的PR字段:WX|QQ|QB|QZ|TRD|TOS|EMUI
        this.parentPackage = ''; // 母版本包，等同QUA2的PP字段:com.tencent.mm|com.tencent.mqq
        this.parentPackageVC = -1; // 母版本号，等同于QUA2-2版本的PPVC字段，QUA2-3已经不存在，使用该字段需要判断iQuaVesion==2
        this.parentPackageVN = ''; // 母版本号，字符串比较大小, 非QB/TBS版本使用该字段判断版本号；等同QUA2-3中的PPVN
        this.tbsVN = ''; // TBS版本，字符串比较大小等同QUA2-3中的TBSVC
        this.device = ''; // 设备屏幕(PHONE)|PAD|TV
        this.api = -1; // 安卓版本API-LEVEL，13|17
        this.keyValue = Object.create(null);
        if (typeof qua === 'string') {
            var ret = false;
            if (qua.indexOf('=') === -1) {
                ret = this.parseQua1(qua);
            }
            else {
                ret = this.parseQua2(qua);
            }
            !ret && console.error("parse qua: " + qua + " failed:", ret);
        }
        else {
            throw new Error("type error: " + typeof qua);
        }
    }
    Qua.prototype.getValueByKey = function (key) {
        return this.keyValue[key] || '';
    };
    ;
    // 用户 WUP 下发 IP 和域名判断
    Qua.prototype.isAndroidHighVersionForWup = function () {
        if (this.platForm === 'ADR') {
            // QUA2版本都是高版本
            return this.quaVersion > 0 || this.build >= 510795;
        }
        return false;
    };
    ;
    /**
     * 获取软件类型 :WX|QQ|QB|QBX|QZ|TRD|TOS|EMUI|TBS
     */
    Qua.prototype.getSoftType = function () {
        return this.softType || '';
    };
    ;
    /**
     * 获取平台:ADR|AP|I|IP|WP|WIN|MAC
     */
    Qua.prototype.getPlatform = function () {
        return this.platForm || '';
    };
    ;
    /**
     * 获取子平台
     */
    Qua.prototype.getSubPlatForm = function () {
        return this.subPlatForm || '';
    };
    ;
    /**
     * 获取机型
     */
    Qua.prototype.getMachine = function () {
        return this.machine || '';
    };
    ;
    /**
     * 获取内核名称，等同 QUA2 的 CO 字段; QUA2-2:IMTT:iOS系统内核
     */
    Qua.prototype.getCoreName = function () {
        return this.coreName || '';
    };
    ;
    /**
     * 获取内核版本，等同 QUA2-2 中的 COVN, QUA2-3 的 COVC
     */
    Qua.prototype.getCoreVersion = function () {
        return this.coreVersion || '';
    };
    ;
    /**
     * 获取版本号，只适用QB/TBS版本，其他的为0，通过sParentPackageVN判断版本
     */
    Qua.prototype.getVersion = function () {
        return this.version || 0;
    };
    ;
    /**
     * 获取子版本，只适用QB/TBS版本，其他的空，通过sParentPackageVN判断版本
     */
    Qua.prototype.getSubVersion = function () {
        return this.subVersion || '';
    };
    ;
    /**
     * 获取 beta 版本号，B1|B2|B3.....
     */
    Qua.prototype.getBetaVersion = function () {
        return this.betaVersion || -1;
    };
    ;
    /**
     * 获取 BUILD 号，【主版本】【子版本】[build]
     */
    Qua.prototype.getBuild = function () {
        return this.build || -1;
    };
    ;
    /**
     * 获取 LCID
     */
    Qua.prototype.getLcId = function () {
        return this.lcId || -1;
    };
    ;
    /**
     * 获取渠道号
     */
    Qua.prototype.getChannel = function () {
        return this.channel || -1;
    };
    ;
    /**
     * 获取屏幕宽度
     */
    Qua.prototype.getWidth = function () {
        return this.width || -1;
    };
    ;
    /**
     * 获取屏幕高度
     */
    Qua.prototype.getHeight = function () {
        return this.height || -1;
    };
    ;
    /**
     * 获取操作系统版本号，如：4.4，会忽略操作系统版本号的最后一位，建议使用 osVersion
     */
    Qua.prototype.getOs = function () {
        return this.os || -1;
    };
    ;
    /**
     * 获取操作系统版本号，如：4.4.2
     */
    Qua.prototype.getOsVersion = function () {
        return this.osVersion || '';
    };
    ;
    /**
     * 获取 QUA 版本号，0:QUA版本 2:QUA2-2版本 3:QUA2-3版本
     */
    Qua.prototype.getQuaVesion = function () {
        return this.quaVersion;
    };
    ;
    /**
     * 获取产品分支，等同 QUA2 的 PB 字段:(GE)|PAD|TV|INT|TMS
     */
    Qua.prototype.getProductBranch = function () {
        return this.productBranch || '';
    };
    ;
    /**
     * 获取产品标识，等同 QUA2 的 PR 字段:WX|QQ|QB|QZ|TRD|TOS|EMUI
     */
    Qua.prototype.getProduct = function () {
        return this.product || '';
    };
    ;
    /**
     * 获取母版本包名，等同 QUA2 的 PP 字段:com.tencent.mm|com.tencent.mqq
     */
    Qua.prototype.getParentPackage = function () {
        return this.parentPackage || '';
    };
    ;
    /**
     * 获取母版本号，等同于 QUA2-2 版本的 PPVC 字段，QUA2-3已经不存在，使用该字段需要判断iQuaVesion==2
     */
    Qua.prototype.getParentPackageVC = function () {
        return this.parentPackageVC || '';
    };
    ;
    /**
     * 获取母版本号，字符串比较大小, 非 QB/TBS 版本使用该字段判断版本号；等同 QUA2-3 中的 PPVN
     */
    Qua.prototype.getParentPackageVN = function () {
        return this.parentPackageVN || '';
    };
    ;
    /**
     * 获取 TBS 版本，字符串比较大小等同 QUA2-3 中的 TBSVC
     */
    Qua.prototype.getTbsVN = function () {
        return this.tbsVN || '';
    };
    ;
    /**
     * 获取设备屏幕(PHONE)|PAD|TV
     */
    Qua.prototype.getDevice = function () {
        return this.device || '';
    };
    ;
    /**
     * 获取安卓版本API-LEVEL，13|17
     */
    Qua.prototype.getApi = function () {
        return this.api || -1;
    };
    ;
    /**
     * 根据 key 直接从键值对读取信息
     */
    Qua.prototype.getKeyValue = function () {
        return this.keyValue || {};
    };
    ;
    /**
     * 把解析出来的信息字符串化，用`|`分割
     */
    Qua.prototype.toString = function () {
        return [
            this.softType,
            this.platForm,
            this.subPlatForm,
            this.machine,
            this.coreName,
            this.coreVersion,
            this.version,
            this.subVersion,
            this.betaVersion,
            this.build,
            this.lcId,
            this.channel,
            this.width,
            this.height,
            this.os,
            this.osVersion,
            this.quaVersion,
            this.productBranch,
            this.product,
            this.parentPackage,
            this.parentPackageVC,
            this.parentPackageVN,
            this.tbsVN,
            this.device,
            this.api,
        ].concat(Object.values(this.keyValue)).join('|');
    };
    ;
    Qua.prototype.parseQua1 = function (qua) {
        var value = qua.split('&');
        if (value.length < 5) {
            console.error("qua1 length error, length = " + value.length);
            return false;
        }
        // ADRQB56_GA/561300&X5MTT_3/015600&ADR&458014& LenovoS810t &74419&9476&Android4.3 &V3
        var softInfo = value[0], sCore = value[1], subPlatForm = value[2], wh = value[3], machine = value[4], channel = value[5], lcId = value[6], osValue = value[7];
        if (wh && wh.length >= 6) {
            this.width = parseInt(wh.substr(0, 2), 10) * 16 || -1;
            this.height = parseInt(wh.substr(2, 2), 10) * 16 || -1;
        }
        this.machine = machine.trim();
        var _a = softInfo.split('/'), snInfo = _a[0], build = _a[1];
        this.build = parseInt(build, 10) || -1;
        if (typeof this.build !== 'number') {
            this.build = 0;
        }
        var _b = snInfo.split('_'), _c = _b[0], sSoftName = _c === void 0 ? '' : _c, _d = _b[1], subVersion = _d === void 0 ? '' : _d;
        // ADRQB24
        var softName = sSoftName.toUpperCase();
        if (softName.indexOf('QB') !== -1) {
            this.platForm = softName.substr(0, softName.indexOf('QB'));
            var verStr = softName.substr(softName.length - 2);
            this.version = parseInt(verStr, 10) || 0;
            this.softType = softName.substr(softName.indexOf('QB'), softName.length - this.platForm.length
                - verStr.length);
        }
        else if (softName.indexOf('QQ') !== -1) {
            this.platForm = softName.substr(0, softName.indexOf('QQ'));
            var posIndex = softName.indexOf('QQ') + 2;
            if (softName.length > posIndex) {
                var verStr = softName.substr(posIndex);
                this.version = parseInt(verStr, 10) || 0;
                this.softType = 'QQ';
            }
        }
        this.subVersion = subVersion;
        if (this.subVersion && this.subVersion.length > 1) {
            if (this.subVersion.substr(0, 1).toUpperCase() === 'B') {
                this.betaVersion = parseInt(this.subVersion.substr(1), 10) || -1;
            }
        }
        this.subPlatForm = subPlatForm;
        if (value[value.length - 1].toUpperCase() === 'V3') {
            if (value.length > 7) {
                this.channel = parseInt(channel, 10) || -1;
                this.lcId = parseInt(lcId, 10) || -1;
                var arr = osValue.match(/([a-zA-Z]+)([0-9.]+)/);
                if ((arr === null || arr === void 0 ? void 0 : arr.length) === 3) {
                    var osVersion = arr[2];
                    this.osVersion = osVersion;
                    this.os = parseFloat(osVersion.split('.').slice(0, 2)
                        .join('.'));
                }
            }
        }
        var core = sCore.split('/');
        if (core.length === 2) {
            this.coreName = core[0].trim();
            this.coreVersion = core[1].trim();
        }
        else {
            this.coreName = '';
            this.coreVersion = '';
        }
        this.quaVersion = 0;
        return true;
    };
    ;
    Qua.prototype.parseQua2 = function (qua) {
        // QUA2解析
        var array = qua.split('&');
        for (var i = 0, l = array.length; i < l; ++i) {
            var iter = array[i];
            var _a = iter.split('='), key = _a[0], _b = _a[1], value = _b === void 0 ? '' : _b;
            if (!key) {
                console.error("parseQua2 err, qua=" + qua);
                return false;
            }
            this.keyValue[key] = value;
        }
        this.quaVersion = Number(this.keyValue.QV);
        // QUA2-3版本解析
        if (this.quaVersion === 2) {
            return this.parseQua22(this.keyValue);
        }
        if (this.quaVersion === 3) {
            return this.parseQua23(this.keyValue);
        }
        console.error("quaVersion error, quaVersion = " + this.quaVersion);
        return false;
    };
    ;
    Qua.prototype.parseQua22 = function (keyValue) {
        if (typeof keyValue !== 'object') {
            return false;
        }
        // coreName
        this.coreName = keyValue.CO;
        // coreVersion
        this.coreVersion = keyValue.COVN;
        // device
        this.device = keyValue.DE;
        // softType
        var st = keyValue.PR;
        if (st) {
            if (st === 'QB' && this.coreName === 'X5') {
                this.softType = 'QBX';
            }
            else {
                this.softType = st;
            }
        }
        // platForm
        var pf = keyValue.PL;
        if (pf) {
            this.platForm = pf;
            if (pf === 'ADR') {
                this.subPlatForm = 'ADR';
                if (this.device === 'PAD') {
                    this.platForm = 'AP';
                    this.subPlatForm = 'AP';
                }
            }
            else if (pf === 'IOS') {
                this.platForm = 'I';
                this.subPlatForm = 'IPH';
                if (this.device === 'PAD') {
                    this.platForm = 'IP';
                    this.subPlatForm = 'IP';
                }
            }
            else {
                this.subPlatForm = pf;
            }
        }
        // machine
        var mo = keyValue.MO;
        if (mo) {
            this.machine = mo.trim();
        }
        // version
        var vs = keyValue.VN;
        if (vs) {
            var vsArray = vs.split('.');
            if (vsArray.length !== 4) {
                console.error("parseQua22 err, VN=" + vs);
                return false;
            }
            var version = vsArray[0] + vsArray[1];
            // 为了兼容老版本，TES/TBS版本号增加80
            if ((this.softType === 'TES') || (this.softType === 'TBS')) {
                this.version = (parseInt(version, 10) || 0) + 80;
            }
            else {
                this.version = parseInt(version, 10) || 0;
            }
            var build = this.version + vsArray[3];
            this.build = parseInt(build, 10) || -1;
        }
        // subVersion
        var sv = keyValue.VE;
        if (sv) {
            this.subVersion = sv;
            if (sv && sv.length > 1) {
                if (sv.substr(0, 1).toUpperCase() === 'B') {
                    this.betaVersion = parseInt(sv.substr(1), 10) || -1;
                }
            }
        }
        // lcId
        var lcId = keyValue.LCID;
        this.lcId = parseInt(lcId, 10) || -1;
        // channel
        var channel = keyValue.CHID;
        this.channel = parseInt(channel, 10) || -1;
        // width, height
        var wh = keyValue.RL;
        if (wh) {
            var whArray = wh.split('*');
            if (whArray.length !== 2) {
                console.error("parseQua22 err, RL= " + wh);
                return false;
            }
            this.width = parseInt(whArray[0], 10) || -1;
            this.height = parseInt(whArray[1], 10) || -1;
        }
        // os
        var os = keyValue.OS;
        if (os) {
            this.os = parseFloat(os) || -1;
            this.osVersion = os;
        }
        // productBranch
        var pb = keyValue.PB;
        if (pb) {
            this.productBranch = pb;
        }
        // parentPackage
        var pp = keyValue.PP;
        if (pp) {
            this.parentPackage = pp;
        }
        // parentPackageVC
        var ppvc = keyValue.PPVC;
        if (ppvc) {
            this.parentPackageVC = parseInt(ppvc, 10) || -1;
        }
        // api
        var api = keyValue.API;
        if (api) {
            this.api = parseInt(api, 10);
        }
        return true;
    };
    ;
    Qua.prototype.parseQua23 = function (keyValue) {
        if (typeof keyValue !== 'object') {
            return false;
        }
        // product
        var product = keyValue.PR;
        if (product) {
            this.product = product;
        }
        // parentPackage
        var pp = keyValue.PP;
        if (pp) {
            this.parentPackage = pp;
        }
        // parentPackageVN
        var ppvn = keyValue.PPVN;
        if (ppvn) {
            this.parentPackageVN = ppvn;
            // QB\TBS\TES满足4段式版本
            if ((this.product === 'QB') || (this.product === 'TBS') || (this.product === 'TES')) {
                var value = ppvn.split('.');
                if (value.length !== 4) {
                    console.error("parseQua23 err, product = " + this.product + ", PPVN = " + ppvn);
                    return false;
                }
                var version = value[0] + value[1];
                // 为了兼容老版本，TES/TBS版本号增加80
                if ((this.softType === 'TES') || (this.softType === 'TBS')) {
                    this.version = (parseInt(version, 10) || 0) + 80;
                }
                else {
                    this.version = parseInt(version, 10) || 0;
                }
                var build = this.version + value[3];
                this.build = parseInt(build, 10) || -1;
            }
        }
        // tbsVN
        var tbsVN = keyValue.TBSVC;
        if (tbsVN) {
            this.tbsVN = tbsVN;
        }
        // coreName
        var cn = keyValue.CO;
        if (cn) {
            this.coreName = cn;
        }
        // coreVersion
        var cv = keyValue.COVC;
        if (cv) {
            this.coreVersion = cv;
        }
        // softType
        var st = keyValue.PR;
        if (st) {
            this.softType = st;
            if (st === 'QB' && ((this.coreName === 'WK') || (this.coreName === 'BK'))) {
                this.softType = 'QBX';
            }
        }
        // platForm
        var pf = keyValue.PL;
        if (pf) {
            this.platForm = pf;
            if (pf === 'ADR') {
                this.subPlatForm = 'ADR';
                // IPAD
                if (this.device === 'PAD') {
                    this.platForm = 'AP';
                    this.subPlatForm = 'AP';
                }
            }
            else if (pf === 'IOS') {
                this.platForm = 'I';
                this.subPlatForm = 'IPH';
                // IPAD
                if (this.device === 'PAD') {
                    this.platForm = 'IP';
                    this.subPlatForm = 'IP';
                }
            }
            else {
                this.subPlatForm = pf;
            }
        }
        // channel
        var channel = keyValue.CHID;
        this.channel = parseInt(channel, 10) || -1;
        // lcId
        var lcId = keyValue.LCID;
        this.lcId = parseInt(lcId, 10) || -1;
        // width,height
        var wh = keyValue.RL;
        if (wh) {
            var value = wh.split('*');
            if (value.length !== 2) {
                console.error("parseQua23 err, RL = " + wh);
                return false;
            }
            this.width = parseInt(value[0], 10) || -1;
            this.height = parseInt(value[1], 10) || -1;
        }
        // machine
        var machine = keyValue.MO;
        if (machine) {
            this.machine = machine.trim();
        }
        // productBranch
        var pb = keyValue.PB;
        if (pb) {
            this.productBranch = pb;
        }
        // device屏幕
        var de = keyValue.DE;
        if (de) {
            this.device = de;
        }
        // subVersion
        var sv = keyValue.VE;
        if (sv) {
            this.subVersion = sv;
            if (sv && typeof sv === 'string' && sv.length > 1) {
                // B1|B2|B3.....
                if (sv.substr(0, 1).toUpperCase() === 'B') {
                    this.betaVersion = parseInt(sv.substr(1), 10);
                }
            }
        }
        // osVersion
        var os = keyValue.OS;
        if (os) {
            this.os = parseFloat(os) || -1;
            this.osVersion = os;
        }
        // api
        var api = keyValue.API;
        if (api) {
            this.api = parseInt(api, 10) || -1;
        }
        return true;
    };
    ;
    return Qua;
}());
module.exports = Qua;
